import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { parsedPhoneNumber } from '../../util/phoneParser'
import searchParamsState from '../../atoms/searchParamsState'
import searchResultsState from '../../atoms/searchResultsState'
import { useSetRecoilState } from 'recoil'

const Search = ({ searchService }) => {
  const setSearchResults = useSetRecoilState(searchResultsState)
  const setSearchParams = useSetRecoilState(searchParamsState)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [allResults, setAllResults] = useState(null)
  const [showAccountsWithoutApplications, setShowAccountsWithoutApplications] =
		useState(false)

  const clearSearch = () => {
    setFirstName('')
    setLastName('')
    setEmail('')
    setPhone('')
    setSearchResults(null)
  }

  const doSearch = async event => {
    event.preventDefault()
    const parsedPhones = phone.split(',').map(pho => parsedPhoneNumber(pho))
    const searchResults = await searchService.getAccounts(
      firstName,
      lastName,
      parsedPhones.join(),
      email,
    )
    setAllResults(searchResults)
  }

  useEffect(() => {
    setSearchParams({
      email,
      firstName,
      lastName,
      phone,
      showAccountsWithoutApplications,
    })
    setSearchResults(allResults)
	}, [allResults, showAccountsWithoutApplications]) // eslint-disable-line

  return (
    <form onSubmit={doSearch}>
      <Box padding={3.5}>
        <Grid
          container
          direction="column"
          justifyContent="space-around"
          spacing={4}
        >
          <Grid item xs={12}>
            <Typography variant="h6">Account Merge Tool</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption">
							*Phone and/or email required
            </Typography>
          </Grid>
          <Grid container item spacing={3}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="phone"
                label="Phone Number*"
                onChange={event => {
                  setPhone(event.target.value)
                }}
                value={phone}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="email"
                label="Email*"
                onChange={event => {
                  setEmail(event.target.value)
                }}
                value={email}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="first"
                label="First Name"
                onChange={event => {
                  setFirstName(event.target.value)
                }}
                value={firstName}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="last"
                label="Last Name"
                onChange={event => {
                  setLastName(event.target.value)
                }}
                value={lastName}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <label htmlFor="show-no-applications-checkbox">
                <input
                  id="show-no-applications-checkbox"
                  onChange={event =>
                    setShowAccountsWithoutApplications(event.target.checked)
                  }
                  type="checkbox"
                />
								Show accounts with NO applications
              </label>
            </Grid>
          </Grid>
          <Grid
            alignItems="center"
            container
            item
            justifyContent="space-around"
          >
            <Grid item>
              <Button color="primary" onClick={clearSearch}>
								Clear Search
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                disabled={!email && !phone}
                type="submit"
                variant="contained"
              >
								Search
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </form>
  )
}

export default Search
